import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { Alert, Button, Stack, Typography } from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import DashBoardCard from '@shared/components/DashBoardCard';
import { Link } from 'react-router-dom';
import { smsMoney, SMS_PROFILE_URL, useSmsSummary } from '../smsCredit';
export function SmsCreditDashboardCard() {
  const { t } = useIntlTranslations();
  const { data, error } = useSmsSummary();
  if (error) {
    return (
      <DashBoardCard title={t('smsDashboard.title')} icon={<SmsOutlinedIcon />}>
        <Alert severity="warning">{t('smsDashboard.loadError')}</Alert>
      </DashBoardCard>
    );
  }
  if (!data?.automatic || (!data.lowCredit && data.available)) {
    return null;
  }
  return (
    <DashBoardCard
      title={t('smsDashboard.title')}
      icon={<SmsOutlinedIcon color="warning" />}
      action={
        <Button component={Link} to={SMS_PROFILE_URL} size="small">
          {t('smsDashboard.topUp')}
        </Button>
      }
    >
      <Stack spacing={1}>
        {data.lowCredit && (
          <>
            <Typography>
              {t('smsDashboard.insufficientBalance', {
                amount: smsMoney(data.balanceHalers),
                days: data.forecastDays,
              })}
            </Typography>
            <Typography variant="body2">
              {t('smsDashboard.forecast', {
                count: data.plannedMessages,
                amount: smsMoney(data.requiredHalers),
                shortfall: smsMoney(data.shortfallHalers),
              })}
            </Typography>
          </>
        )}
        {!data.available && <Alert severity="info">{t('smsCredit.sendingInactive')}</Alert>}
      </Stack>
    </DashBoardCard>
  );
}
